import { render } from "./Badge1.vue?vue&type=template&id=8d4a370a&scoped=true"
import script from "./Badge1.vue?vue&type=script&lang=js"
export * from "./Badge1.vue?vue&type=script&lang=js"

import "./Badge1.vue?vue&type=style&index=0&id=8d4a370a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4a370a"]])

export default __exports__